import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { sessionService } from 'redux-react-session';
import rootReducer from '../reducers/index';

const store = createStore(rootReducer, applyMiddleware(thunk));
sessionService.initSessionService(store);
export default store;



// WEBPACK FOOTER //
// ./src/config/Store.js